import React, { useEffect, useState } from 'react'
import TablaAccesos from './TablaAccesos'
import WhiteArrowRight from '../../../../media/felsv/dark_left-arrow_icon.svg'
import {useDispatch, useSelector} from 'react-redux'
import {
  gu_cu_ChangePage,
  gu_cu_ShowModalConfirmar,
} from '../../../../actions/gestion-usuario/creacion-usuario/creacionUsuario.actions'
import {State} from '../../../../reducers'

const CUStep2Sucursal = () => {
  const dispatch = useDispatch()
  const sucursalesAsignadas = useSelector((state: State) => state.gestionUsuario.creacionUsuario.sucursalesAsignadas)
  const finalizar = () => dispatch(gu_cu_ShowModalConfirmar(true))
  const regresar = () => dispatch(gu_cu_ChangePage(-1))
  const [ShowNextBTN, setShowNextBTN] = useState<boolean>(false)

  useEffect(() => {
    if(sucursalesAsignadas.length > 0)
      setShowNextBTN(true)
    else
      setShowNextBTN(false)
  }, [sucursalesAsignadas])

  return (
    <div className=' w-100 mb-1'>
      <div className='card w-form card-basic w-100'>
        <h3 className='card-title l mb-16'>Accesos</h3>
        <br />
        <div className='separador'></div>
        <div>
          <TablaAccesos />
        </div>
      </div>
      <div
        className='mt-16 w-100  button-actions'
        style={{display: 'flex', justifyContent: 'space-between'}}
      >
        <button
          type='button'
          className='m button transparent w-inline-block w-auto'
          onClick={regresar}
        >
          <img src={WhiteArrowRight} loading='lazy' alt='Siguiente' />
          <div>Regresar</div>
        </button>
        <button type='submit' disabled={!ShowNextBTN} className='m button w-inline-block w-auto' onClick={finalizar}>
          <div>Finalizar</div>
        </button>
      </div>
    </div>
  )
}

export default CUStep2Sucursal
